import { render, staticRenderFns } from "./ScanReview.vue?vue&type=template&id=54141d25&"
import script from "./ScanReview.vue?vue&type=script&lang=js&"
export * from "./ScanReview.vue?vue&type=script&lang=js&"
import style0 from "./ScanReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports